/** クーポンコード更新. */
export const UPDATE_COUPON_CODE = "UPDATE_COUPON_CODE";